import styles from './Socials.module.scss';

const socials = [
    {id: 0, link: 'https://t.me/telekanal2x2'},
    {id: 1, link: 'https://ok.ru/2x2tv'},
    {id: 2, link: 'https://vk.com/2x2tv'}
];

const socialsArray = ['ТГ', 'ОК', 'ВК'];

export const Socials = () => {

    const list = socials.map(item => {
        const {id, link} = item;

        return (
            <li className={styles.item} key={id}>
                <a href={link} className={styles.link} target="_blank" rel="nofollow noreferrer">
                    {socialsArray[id]}
                </a>
            </li>
        )
    });

    return (
        <ul className={styles.list}>
            {list}
        </ul>
    );
};
